@if (isLoading()) {
  <aw-loading-animation
    [entityType]="EEntityType.ticketConfiguration"
    [relationType]="
      RelationType.loadingDirectTicketOptions
    "></aw-loading-animation>
}
@if (
  !isLoading() &&
  ticketsInCart().length > 0 &&
  ticketsInCart()[0].productForm.value.product
) {
  <div class="flex flex-col gap-6 md:flex-row">
    <div class="flex w-full flex-col gap-4 md:w-2/3">
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'ticket-option-configuration-page-section'">
        <aw-ticket-options-form
          [positionInCart]="0"
          [tariffProductGroup]="
            shoppingCartService.productForms.controls[0].controls.tariffGroup
              .value!
          "
          [productDefinition]="ticketsInCart()[0]!.productForm.value!.product!"
          [productForm]="
            shoppingCartService.productForms.controls[0]
          "></aw-ticket-options-form>
      </aw-section>
    </div>
    <aw-direct-ticket-configuration-shopping-cart
      class="fixed bottom-0 left-0 z-20 w-full md:relative md:w-1/3"
      [page]="EPage.Configuration"
      [attr.data-testid]="'ticket-option-configuration-page-shopping-cart'"
      [isDisabled]="
        !shoppingCartService.productForms.valid || !currentProductDefinition()
      "
      (onButtonClick)="
        proceedToPersonalData()
      "></aw-direct-ticket-configuration-shopping-cart>
  </div>
}
